<template>
  <div class="aside-options">
    <router-link
      v-if="$route.name !== 'product-details'"
      :to="{ name: 'product-details', params: { id: $route.params.id } }"
      class="btn mt-5 home"
      @click.native="$emit('closeMenu')"
    >
      <i class="icon-arrow-left"></i>
      <span>Painel do produto</span>
    </router-link>
    <button
      v-if="$route.name === 'product-details'"
      class="btn mt-5 home"
      @click="$emit('back')"
    >
      <i class="icon-arrow-left"></i>
      <span>Painel do produto</span>
    </button>
    <router-link
      :to="{ name: 'home' }"
      class="btn mt-5 home"
      @click.native="$emit('closeMenu')"
    >
      <i class="icon-dashboard"></i>
      <span>Inicio</span>
    </router-link>

    <button
      class="btn"
      :class="
        ['product-member-area-modules', 'product-member-area-modules'].includes(
          $route.name
        )
          ? 'active-item-indiciator'
          : ''
      "
      @click="$emit('toggleContext', 'content')"
    >
      <i class="icon-content"></i>
      <span class="">Área de Membros</span>
      <i
        class="icon-angle-right"
        :class="{
          'rotate-90-clock': openContext === 'content'
        }"
      ></i>
    </button>
    <div
      v-if="openContext === 'content' && (showMenu || lockedMenu)"
      class="pl-5"
    >
      <router-link
        :to="{
          name: 'product-member-area-setup',
          params: { id: $route.params.id }
        }"
        class="btn context-option"
        @click.native="$emit('closeMenu')"
      >
        <span>Configurações</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-modules',
          params: { id: $route.params.id }
        }"
        class="btn context-option"
        @click.native="$emit('closeMenu')"
      >
        <span>Conteúdo</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-categories',
          params: { id: $route.params.id }
        }"
        class="btn context-option"
        @click.native="$emit('closeMenu')"
      >
        <span>Categorias</span>
        <div class="news">
          <i class="icon-news-star" />
          <span>Novo !</span>
        </div>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-students',
          params: { id: $route.params.id }
        }"
        class="btn context-option"
        @click.native="$emit('closeMenu')"
      >
        <span>Alunos</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-groups',
          params: { id: $route.params.id }
        }"
        class="btn"
        @click.native="$emit('closeMenu')"
      >
        <span>Turmas</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-comments',
          params: { id: $route.params.id }
        }"
        class="btn context-option"
        @click.native="$emit('closeMenu')"
      >
        <span>Comentários</span>
      </router-link>
    </div>

    <router-link
      class="btn"
      :to="{
        name: 'product-upsell',
        params: { id: this.$route.params.id }
      }"
    >
      <i class="icon-upsell"></i>
      <span>Funil de vendas</span>
    </router-link>
    <!-- <button class="btn">
      <i class="icon-shopping-cart"></i>
      <span>Vendas</span>
    </button> -->
    <!-- <button
      class="btn"
      :class="
        ['product-reports-sales'].includes($route.name)
          ? 'active-item-indiciator'
          : ''
      "
      @click="$emit('toggleContext', 'reports-producer')"
    >
      <i class="icon-analytics"></i>
      <span class="">Relatórios</span>
      <i
        class="icon-angle-right"
        :class="{
          'rotate-90-clock': openContext === 'reports-producer'
        }"
      ></i>
    </button>
    <div
      v-if="openContext === 'reports-producer' && (showMenu || lockedMenu)"
      class="pl-5"
    >
      <router-link
        :to="{
          name: 'product-reports-sales',
          params: { id: $route.params.id }
        }"
        class="btn context-option"
        @click.native="$emit('closeMenu')"
      >
        <span>Vendas</span>
      </router-link>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    showMenu: {
      type: Boolean,
      default: false
    },
    lockedMenu: {
      type: Boolean,
      default: false
    },
    indicatorClasses: {
      type: String,
      default: ""
    },
    openContext: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.aside-options {
  width: 100%;
  transition: width 0.15s;

  ::v-deep.btn {
    width: 100%;
    color: rgba(255, 255, 255, 0.8);
    display: flex;
    cursor: pointer;
    padding-top: 12px;
    padding-bottom: 12px;
    justify-content: flex-start;

    &.router-link-active:not(.home),
    &.router-link-exact-active {
      @media screen and (min-width: 576px) {
        border-right: 4px solid white;
      }
      @media screen and (max-width: 575px) {
        border-left: 4px solid white;
      }
    }

    span {
      margin-left: 12px;
      white-space: nowrap;
      flex: 1 1 auto;
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &:hover {
      color: white;
      .news {
        i {
          font-size: 0;
          min-width: 0;
          width: 0px;
          opacity: 0;
        }
        span {
          font-size: 14px;
          opacity: 1;
        }
      }
    }

    i {
      font-size: 24px;
      min-width: 46px;

      &.menu {
        font-size: 32px;
        line-height: 44px;
        color: rgba(51, 51, 51, 0.6);
      }
    }
    .news {
      padding: 4px;
      height: 30px;
      display: flex;
      border-radius: 8px;
      align-items: center;
      background: #423d4d;
      transition: 0.1s opacity;
      border: 1px solid rgba(230, 213, 255, 0.85);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      span,
      i {
        margin: 0 !important;
        transition: all 0.3s;
        color: rgba(230, 213, 255, 0.85) !important;
      }
      i {
        min-width: 24px;
      }
      span {
        opacity: 0;
        font-size: 0;
      }
    }
    &:has(.news) {
      span {
        flex: 1;
      }
    }
  }

  .active-item-indiciator {
    font-weight: bold;
    border-right: 4px solid white;
    background: rgba(255, 255, 255, 0.05);
    @media screen and (min-width: 576px) {
      padding-left: 13px;
    }
    @media screen and (max-width: 575px) {
      padding-left: 9px;
    }
  }
}
</style>
